// import { Wrench, Sparkles, ArrowRight } from "lucide-react";
// import { motion } from "framer-motion";

// export const Services = () => {
//   // const services = [
//   //   "Business Website (3–5 Pages)",
//   //   "E-Commerce Store (Cart + Payment)",
//   //   "Portfolio Website",
//   //   "Landing Page for Ads",
//   //   "Blog Website",
//   //   "Website Redesign / Speed Optimization",
//   //   "Hosting & Domain Guidance",
//   //   "WhatsApp Chat Integration",
//   // ];

//   const services = [
//     "Custom Business Website Development",
//     "Advanced E-Commerce Store (Cart, Payment & Order System)",
//     "Modern Admin Dashboard Development",
//     "High-Converting Landing Pages for Ads & Campaigns",
//     "Portfolio & Personal Brand Websites",
//     "Multi-Vendor Marketplace Development",
//     "Responsive UI/UX Design with Modern Animations",
//     "Website Redesign & Performance Optimization",
//     "SEO-Friendly Website Structure",
//     "Secure Authentication & User Management System",
//     "Real-Time Analytics & Reporting Dashboard",
//     "API Integration & Backend Connectivity",
//     "WhatsApp Chat & Live Support Integration",
//     "Hosting, Domain & Deployment Support",
//     "Speed Optimization & Core Web Vitals Fixes",
//     "Mobile-Friendly & Cross-Browser Development",
//     "CMS & Blog Website Development",
//     "Custom Forms, Booking & Management Systems",
//     "Maintenance, Bug Fixing & Technical Support",
//     "Scalable Web Solutions for Business Growth",
//   ];



//   return (
//     <section id="services" className="relative bg-gray-50 text-gray-800 py-16 px-6">


//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         {/* Floating circles */}
//         {/* {[...Array(8)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute rounded-full bg-emerald-400/20"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               width: `${Math.random() * 200 + 50}px`,
//               height: `${Math.random() * 200 + 50}px`,
//             }}
//             animate={{
//               scale: [1, 1.2, 1],
//               rotate: [0, 180, 360],
//               y: [0, Math.random() * 50 - 25, 0],
//               x: [0, Math.random() * 30 - 15, 0],
//             }}
//             transition={{
//               duration: Math.random() * 15 + 15,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))} */}

//         {/* Floating squares */}
//         {[...Array(5)].map((_, i) => (
//           <motion.div
//             key={`square-${i}`}
//             className="absolute bg-blue-400/10"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               width: `${Math.random() * 100 + 30}px`,
//               height: `${Math.random() * 100 + 30}px`,
//               rotate: `${Math.random() * 45}deg`,
//             }}
//             animate={{
//               rotate: [0, 45, 90, 135, 180, 225, 270, 315, 360],
//               y: [0, Math.random() * 40 - 20, 0],
//             }}
//             transition={{
//               duration: Math.random() * 20 + 20,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}

//         {/* Floating triangles */}
//         {[...Array(4)].map((_, i) => (
//           <motion.div
//             key={`triangle-${i}`}
//             className="absolute w-0 h-0 border-transparent"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               borderLeftWidth: `${Math.random() * 40 + 20}px`,
//               borderRightWidth: `${Math.random() * 40 + 20}px`,
//               borderBottomWidth: `${Math.random() * 60 + 30}px`,
//               borderBottomColor: `rgba(110, 231, 183, ${Math.random() * 0.1 + 0.1})`,
//             }}
//             animate={{
//               rotate: [0, 180, 360],
//               y: [0, Math.random() * 60 - 30, 0],
//             }}
//             transition={{
//               duration: Math.random() * 25 + 25,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}

//         {/* Animated gradient orbs */}
//         <motion.div
//           className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-gradient-to-r from-blue-300/30 to-emerald-300/30 blur-3xl"
//           animate={{
//             scale: [1, 1.2, 1],
//             opacity: [0.3, 0.5, 0.3],
//           }}
//           transition={{
//             duration: 8,
//             repeat: Infinity,
//             ease: "easeInOut"
//           }}
//         />
//         <motion.div
//           className="absolute bottom-1/3 right-1/3 w-80 h-80 rounded-full bg-gradient-to-r from-emerald-300/30 to-blue-300/30 blur-3xl"
//           animate={{
//             scale: [1.2, 1, 1.2],
//             opacity: [0.5, 0.3, 0.5],
//           }}
//           transition={{
//             duration: 10,
//             repeat: Infinity,
//             ease: "easeInOut"
//           }}
//         />

//         {/* Particle animation */}
//         {[...Array(20)].map((_, i) => (
//           <motion.div
//             key={`particle-${i}`}
//             className="absolute w-2 h-2 rounded-full bg-emerald-400/40"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//             }}
//             animate={{
//               y: [0, -30, 0],
//               opacity: [0, 1, 0],
//             }}
//             transition={{
//               duration: Math.random() * 5 + 3,
//               repeat: Infinity,
//               delay: Math.random() * 2,
//             }}
//           />
//         ))}
//       </div>

//       <div className="max-w-4xl mx-auto">
//         {/* Header Section */}
//         <motion.div
//           className="text-center mb-12"
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.7, ease: "easeOut" }}
//           viewport={{ once: false }}
//         >
//           {/* <motion.div
//             className="inline-flex items-center justify-center mb-4"
//             animate={{
//               scale: [1, 1.05, 1],
//               rotate: [0, 5, 0, -5, 0]
//             }}
//             transition={{
//               duration: 4,
//               repeat: Infinity,
//               ease: "easeInOut"
//             }}
//           >
//             <Sparkles className="text-blue-500 mr-2" size={28} />
//             <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-emerald-500 text-transparent bg-clip-text inline-block">
//               Web Development Services
//             </h2>
//             <Sparkles className="text-emerald-500 ml-2" size={28} />
//           </motion.div>

//           <motion.p
//             className="text-lg max-w-2xl mx-auto text-gray-700 mt-4"
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ delay: 0.3, duration: 0.7 }}
//             viewport={{ once: false }}
//           >
//             I specialize in crafting powerful, responsive websites tailored for
//             businesses, creators, and startups. Each project receives personalized attention.
//           </motion.p> */}

//           <motion.div
//   className="inline-flex items-center justify-center mb-4"
//   animate={{
//     scale: [1, 1.05, 1],
//     rotate: [0, 5, 0, -5, 0]
//   }}
//   transition={{
//     duration: 4,
//     repeat: Infinity,
//     ease: "easeInOut"
//   }}
// >
//   <Sparkles className="text-[#0F63C9] mr-2" size={28} />

//   <h2 className="text-3xl md:text-5xl font-black leading-tight bg-gradient-to-r from-[#0F63C9] via-blue-500 to-emerald-500 text-transparent bg-clip-text inline-block">
//     Building Digital Experiences <br className="hidden md:block" />
//     That People Remember
//   </h2>

//   <Sparkles className="text-emerald-500 ml-2" size={28} />
// </motion.div>

// <motion.p
//   className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 mt-5 leading-relaxed font-medium"
//   initial={{ opacity: 0, y: 20 }}
//   whileInView={{ opacity: 1, y: 0 }}
//   transition={{ delay: 0.3, duration: 0.7 }}
//   viewport={{ once: false }}
// >
//   Your website is more than just a design — it’s your brand’s first impression.
//   I create fast, modern, and visually powerful web experiences that help businesses
//   stand out, build credibility, and turn visitors into loyal customers.
// </motion.p>
//         </motion.div>

//         {/* Services Grid */}
//         <motion.div
//           className="grid grid-cols-1 md:grid-cols-2 gap-6"
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: false, margin: "-50px" }}
//           variants={{
//             visible: {
//               transition: {
//                 staggerChildren: 0.1,
//               },
//             },
//           }}
//         >
//           {services.map((service, index) => (
//             <motion.div
//               key={index}
//               className="bg-white rounded-xl p-5 shadow-md border border-gray-100 relative overflow-hidden group hover:shadow-lg transition-all duration-300"
//               variants={{
//                 hidden: { opacity: 0, y: 20 },
//                 visible: {
//                   opacity: 1,
//                   y: 0,
//                   transition: {
//                     duration: 0.5,
//                     ease: "easeOut"
//                   }
//                 },
//               }}
//               whileHover={{
//                 y: -5,
//                 transition: { duration: 0.2 }
//               }}
//             >
//               {/* Glow effect */}
//               <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-emerald-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl"></div>

//               <div className="flex items-start relative z-10">
//                 <motion.div
//                   className="flex-shrink-0 bg-gradient-to-r from-blue-500 to-emerald-500 p-2 rounded-lg mr-4"
//                   whileHover={{ rotate: 15 }}
//                   transition={{ type: "spring", stiffness: 300 }}
//                 >
//                   <Wrench className="text-white" size={20} />
//                 </motion.div>
//                 <span className="text-gray-800 font-medium group-hover:text-blue-600 transition-colors duration-300">{service}</span>

//                 <motion.div
//                   className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                   animate={{ x: [0, 5, 0] }}
//                   transition={{ duration: 1.5, repeat: Infinity }}
//                 >
//                   <ArrowRight className="text-emerald-500" size={18} />
//                 </motion.div>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>

//         {/* Call to Action */}
//         <motion.div
//           className="text-center mt-12"
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.5, duration: 0.7 }}
//           viewport={{ once: false }}
//         >
//           <motion.button
//             className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white font-semibold py-3 px-8 rounded-full relative overflow-hidden group"
//             whileHover={{
//               scale: 1.05,
//               transition: { duration: 0.3 }
//             }}
//             whileTap={{ scale: 0.95 }}
//             onClick={() => { window.location.href = 'https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project'; }}
//           >
//             <span className="relative z-10">Start Your Project</span>

//             {/* Button glow effect */}
//             <motion.div
//               className="absolute inset-0 bg-gradient-to-r from-blue-500 to-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
//               animate={{
//                 x: ["-100%", "200%"],
//               }}
//               transition={{
//                 duration: 1.5,
//                 repeat: Infinity,
//                 repeatType: "loop",
//                 ease: "linear"
//               }}
//             />
//           </motion.button>

//           <motion.p
//             className="text-gray-600 mt-4 text-sm"
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ delay: 0.8, duration: 0.5 }}
//             viewport={{ once: false }}
//           >
//             Let's discuss your project with a  consultation
//           </motion.p>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

import { Wrench, Sparkles, ArrowRight, CheckCircle2, Zap, Globe, ShoppingCart, Layout, Smartphone, Shield, BarChart3, Users, Settings, Rocket, Code, PenTool, Database, MessageCircle, CloudCog, Gauge, Brush, Server } from "lucide-react";
import { motion, useMotionTemplate, useMotionValue, useSpring, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";

export const Services = () => {
  const services = [
    { name: "Custom Business Website Development", icon: Globe, description: "Tailored websites that reflect your brand identity and drive results" },
    { name: "Advanced E-Commerce Store", icon: ShoppingCart, description: "Complete cart, payment & order systems for seamless selling" },
    { name: "Modern Admin Dashboard Development", icon: Layout, description: "Powerful backends to manage your business efficiently" },
    { name: "High-Converting Landing Pages", icon: Zap, description: "Optimized pages designed for maximum ad campaign ROI" },
    { name: "Portfolio & Personal Brand Websites", icon: PenTool, description: "Stand out with stunning, creative portfolios" },
    { name: "Multi-Vendor Marketplace Development", icon: Users, description: "Build your own Amazon-style marketplace" },
    // { name: "Responsive UI/UX Design", icon: Smartphone, description: "Modern animations and flawless mobile experiences" },
    { name: "Website Redesign & Performance", icon: Gauge, description: "Speed optimization and complete visual overhauls" },
    { name: "SEO-Friendly Structure", icon: BarChart3, description: "Built to rank higher on search engines" },
    { name: "Secure Authentication System", icon: Shield, description: "Robust user management and data protection" },
    { name: "Real-Time Analytics Dashboard", icon: BarChart3, description: "Track performance with live data insights" },
    { name: "API Integration & Backend", icon: Database, description: "Connect any third-party service seamlessly" },
    { name: "WhatsApp Chat & Live Support", icon: MessageCircle, description: "Engage visitors instantly with smart chat" },
    { name: "Hosting & Deployment Support", icon: CloudCog, description: "Full setup from domain to launch" },
    { name: "Speed Optimization & Core Web Vitals", icon: Rocket, description: "Lightning-fast performance guaranteed" },
    { name: "Cross-Browser Development", icon: Code, description: "Perfect on every browser and device" },
    { name: "CMS & Blog Development", icon: Settings, description: "Easy-to-manage content systems" },
    { name: "Custom Booking Systems", icon: CheckCircle2, description: "Appointments, reservations and management" },
    { name: "Maintenance & Support", icon: Server, description: "Ongoing care and technical assistance" },
    // { name: "Scalable Business Solutions", icon: Rocket, description: "Grow without limits with future-proof code" },
  ];

  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { once: false, margin: "-100px" });
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const springX = useSpring(mouseX, { stiffness: 300, damping: 30 });
  const springY = useSpring(mouseY, { stiffness: 300, damping: 30 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const rect = containerRef.current?.getBoundingClientRect();
      if (rect) {
        mouseX.set(e.clientX - rect.left);
        mouseY.set(e.clientY - rect.top);
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [mouseX, mouseY]);

  return (
    <section 
      ref={containerRef}
      id="services" 
      className="relative bg-gradient-to-br from-gray-50 via-white to-gray-50 py-24 px-6 overflow-hidden"
    >
      {/* Animated Background Gradient Follows Mouse */}
      <motion.div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          background: useMotionTemplate`radial-gradient(circle at ${springX}px ${springY}px, rgba(15,99,201,0.15), rgba(16,185,129,0.05) 60%, transparent 80%)`,
        }}
      />

      {/* Sophisticated animated particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(30)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-gradient-to-r from-blue-500/20 to-emerald-500/20"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 6 + 2}px`,
              height: `${Math.random() * 6 + 2}px`,
            }}
            animate={{
              y: [0, -50, 0],
              x: [0, Math.random() * 30 - 15, 0],
              opacity: [0, 0.6, 0],
              scale: [1, 1.5, 1],
            }}
            transition={{
              duration: Math.random() * 8 + 4,
              repeat: Infinity,
              delay: Math.random() * 5,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header Section - More compelling with benefit-driven copy */}
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          viewport={{ once: false }}
        >
          <motion.div
            className="inline-flex items-center justify-center mb-6"
            animate={{
              scale: [1, 1.05, 1],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              repeatType: "reverse",
            }}
          >
            <div className="flex items-center gap-3 bg-gradient-to-r from-blue-500/10 to-emerald-500/10 backdrop-blur-sm px-6 py-2 rounded-full border border-blue-200/30">
              <Sparkles className="text-blue-600 w-5 h-5" />
              <span className="text-sm font-semibold bg-gradient-to-r from-blue-700 to-emerald-600 bg-clip-text text-transparent">
                What I Deliver
              </span>
              <Sparkles className="text-emerald-500 w-5 h-5" />
            </div>
          </motion.div>

          <motion.h2 
            className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tight mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.6 }}
          >
            <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
              Solutions That
            </span>
            <br />
            <span className="bg-gradient-to-r from-blue-600 via-emerald-500 to-blue-600 bg-clip-text text-transparent">
              Convert & Captivate
            </span>
          </motion.h2>

          <motion.p
            className="text-xl md:text-2xl max-w-4xl mx-auto text-gray-600 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            Your website is your most powerful asset. I combine stunning design with 
            proven strategies to turn visitors into lifelong customers.
          </motion.p>

          <motion.div 
            className="flex flex-wrap justify-center gap-4 mt-8"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {["3+ Years Experience", "20+ Projects Delivered", "24/7 Support", "100% Satisfaction"].map((badge, idx) => (
              <motion.span
                key={idx}
                className="px-4 py-1.5 bg-white/70 backdrop-blur-sm rounded-full text-sm font-medium text-gray-700 border border-gray-200 shadow-sm"
                whileHover={{ scale: 1.05, backgroundColor: "white" }}
              >
                {badge}
              </motion.span>
            ))}
          </motion.div>
        </motion.div>

        {/* Services Grid - Card hover effects and icons updated */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, margin: "-50px" }}
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                staggerChildren: 0.05,
              },
            },
          }}
        >
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                className="group relative bg-white rounded-2xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 hover:border-blue-200 transition-all duration-500 cursor-pointer overflow-hidden"
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    transition: {
                      duration: 0.5,
                      ease: [0.25, 0.1, 0.25, 1],
                    },
                  },
                }}
                whileHover={{
                  y: -8,
                  transition: { duration: 0.3, ease: "easeOut" },
                  boxShadow: "0 25px 40px -12px rgba(0,0,0,0.15)"
                }}
              >
                {/* Animated gradient border on hover */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/0 via-blue-500/20 to-emerald-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 rounded-2xl -z-0" />
                
                <div className="relative z-10">
                  <div className="flex items-start gap-4 mb-4">
                    <motion.div
                      className="flex-shrink-0 bg-gradient-to-br from-blue-500 to-emerald-500 p-3 rounded-xl shadow-lg"
                      whileHover={{ rotate: 5, scale: 1.05 }}
                      transition={{ type: "spring", stiffness: 400 }}
                    >
                      <Icon className="text-white w-5 h-5" />
                    </motion.div>
                    <div className="flex-1">
                      <h3 className="font-bold text-gray-800 text-lg group-hover:text-blue-600 transition-colors duration-300">
                        {service.name}
                      </h3>
                      <p className="text-gray-500 text-sm mt-1 line-clamp-2">
                        {service.description}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex justify-end mt-2">
                    <motion.div
                      className="opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 group-hover:translate-x-0"
                      initial={{ opacity: 0, x: -5 }}
                      whileInView={{ opacity: 0, x: -5 }}
                      whileHover={{ opacity: 1, x: 0 }}
                    >
                      <CheckCircle2 className="text-emerald-500 w-5 h-5" />
                    </motion.div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>

        {/* Enhanced Call to Action - Client conversion focused */}
        <motion.div
          className="text-center mt-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.7 }}
          viewport={{ once: false }}
        >
          <div className="relative inline-block">
            <motion.div
              className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full blur-xl opacity-70 group-hover:opacity-100 transition duration-1000"
              animate={{
                scale: [1, 1.05, 1],
                opacity: [0.5, 0.8, 0.5],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
            <motion.button
              className="relative bg-gradient-to-r from-blue-600 to-emerald-500 text-white font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 mx-auto text-lg"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 15px 35px -10px rgba(15,99,201,0.5)",
              }}
              whileTap={{ scale: 0.98 }}
              onClick={() => {
                window.location.href =
                  "https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project";
              }}
            >
              <span>Start Your Project Today</span>
              <Rocket className="w-5 h-5" />
            </motion.button>
          </div>

          <motion.div
            className="mt-6 flex items-center justify-center gap-2 text-gray-500 text-sm"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
            <span>No upfront payment required</span>
            <span className="w-1 h-1 bg-gray-300 rounded-full mx-2"></span>
            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
            <span>Free consultation</span>
            <span className="w-1 h-1 bg-gray-300 rounded-full mx-2"></span>
            <CheckCircle2 className="w-4 h-4 text-emerald-500" />
            <span>100% money-back guarantee</span>
          </motion.div>
          
          <motion.p
            className="text-gray-500 mt-6 text-sm max-w-md mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.7 }}
          >
            ⚡ Limited slots available this month. Book your free strategy call now.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};